(() => {
  // Home 4.0 quick add: adds to cart via AJAX and opens the theme's cart drawer; falls back to /cart.
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  async function add(form) {
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      const drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
        const toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        if (toggle) toggle.click();
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (e) {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('[data-drf-home-add]');
    if (!form) return;
    event.preventDefault();
    add(form);
  });
})();
